import { AudioControlWrapper as AudioControl } from '../../session/controls/AudioControl';
import { useOpenHelpModalCallback } from './useOpenHelpModalCallback';

export function ProviderAudioControlWrapper() {
  const openHelpModal = useOpenHelpModalCallback();

  return <AudioControl openHelpModal={openHelpModal} />;
}
